var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"card p-3"},[_c('div',{staticClass:"card-body"},[_c('h2',{staticClass:"card-title-desc"},[_vm._v("Record Shipment")]),_c('shipment-form',{attrs:{"button_text":"Add Shipment"},on:{"shipmentAction":_vm.recordShipment}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }